import React from 'react'
import AwsConfig from '../../Config/AwsConfig'

export default function MoviePersonAutoSuggestions(props) {
  const { autoSuggestions, searchBarVisible, handleSelectAutoSuggestion } = props
  return (
    <>
      {autoSuggestions.length >= 1 && searchBarVisible && (
        <div
          style={{
            // width: '50%',
            // border: '0.063rem solid lightblue',
            height: '18.75rem',
            // borderRadius: '0.63rem',
            overflow: 'auto',
          }}
        >
          {searchBarVisible &&
            autoSuggestions.map((suggestionData, suggestionIndex) => {
              let { poster } = suggestionData
              if (poster && !poster.includes(AwsConfig.movieCdnUrl)) {
                poster = AwsConfig.movieCdnUrl + poster
              }

              return (
                <div
                  key={suggestionIndex}
                  onClick={() => handleSelectAutoSuggestion(suggestionIndex)}
                >
                  <ul className='list-group list-group-flush mb-1'>
                    <li className='list-group-item'>
                      <div className='media d-flex justify-content-center align-items-center'>
                        <img
                          style={{ width: '2rem', height: '2rem' }}
                          className='rounded-circle mr-3'
                          src={poster}
                        />
                        <div className='media-body align-self-center'>
                          <label>{suggestionData.label}</label>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              )
            })}
        </div>
      )}
    </>
  )
}
